import { createContext } from "react";

export const diagramVersionHoverContext = createContext({
    version: null,
    setVersionAndElement: (ver, el) => {},
    element: null // type HTMLDivElement
});
